import React from "react";
import Image from "next/future/image";
import UseCasesCarousel from "./UseCasesCarosel";
import { Section1 } from "./Constants";

const ConferencesAndSummits = ({ title }) => {
  return (
    <>
      <div
        className={`${title}-root d-flex justify-content-center align-items-center flex-row px-5 px-mob pb-5 pt-4 g-0`}
      >
        <div className={`row`}>
          <div
            className={`col-lg-6 mob-none col py-md-3 d-flex justify-content-center flex-column align-items-center px-md-3 ps-lg-5 pe-lg-5 py-3`}
          >
            <div
              className={`${title}-image mx-md-5 d-flex justify-content-center align-items-center px-md-3`}
            >
              <Image
                className={`${title}-RootImageDesktop`}
                src="/img/useCases/ConferenceAndSummits.png"
                alt="ConferencesAndSummits"
                width={550}
                height={390}
              />
            </div>
          </div>
          <div
            className={`col-lg-6 col pb-md-3 pt-md-5 px-md-3 py-3 px-lg-3 ps-lg-5 ${title}-details-root`}
          >
            <h2 className={`${title}-title`}>
              Conferences & Summits
              {/* <span><img src={Chain} alt="link" /></span> */}
            </h2>
            <div className={`${title}-text mt-1`}>
              KonfHub simplifies event planning with customizable features
            </div>
            <div
              className={`${title}-image mx-md-5 desktop-none d-flex justify-content-center align-items-center px-md-3`}
            >
              <Image
                className={`${title}-RootImageDesktop`}
                src="/img/useCases/ConferenceAndSummits.png"
                alt="ConferencesAndSummits"
                width={320}
                height={225}
              />
            </div>
            <div className={`${title}-subText mt-md-4`}>
              KonfHub can simplify the lives of event organizers by assisting
              with the planning of large tech conferences, whether organized by
              corporate or developer/student communities. KonfHub helps your
              life as an organizer easier.
              <ul>
                <li>Increase registrations with automated referral contests</li>
                <li>
                  Utilize customizable ticketing options to fit your
                  requirements
                </li>
                <li>
                  Keep attendees engaged with live quizzes during the event
                </li>
                <li>
                  Benefit from features such as hidden tickets and
                  approval-based registrations
                </li>
                <li>Conveniently use check-in and sponsor apps</li>
              </ul>
            </div>
          </div>
          <div>
            <UseCasesCarousel data={Section1} />
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .${title}-root {
            background: #ffffff;
            padding: 50px 0px;
            padding-left: 105px;
            padding-right: 105px;
          }
          .${title}-root .${title}-details-root {
            padding-left: 0px;
          }
          .${title}-root .${title}-details-root .${title}-title {
            font-family: "Nunito";
            font-weight: 800;
            font-size: 42px;
            line-height: 57px;
            color: #572148;
          }
          .${title}-root .${title}-details-root .${title}-text {
            font-family: "Nunito";
            font-weight: 700;
            font-size: 22px;
            line-height: 30px;
            text-align: left;
            color: #616161;
          }
          .desktop-none {
            display: none !important;
          }
          .${title}-root .${title}-details-root .${title}-subText {
            font-family: "Nunito";
            font-weight: 500;
            font-size: 18px;
            line-height: 27px;
            color: #4f4f4f;
          }
          .${title}-root .${title}-RootImageDesktop {
            max-width: 100%;
          }
          .${title}-root .${title}-image {
            margin-top: 10px;
            max-width: 100%;
          }
          @media screen and (max-width: 722px) {
            .${title}-root {
              padding-left: 50px;
              padding-right: 50px;
            }
            .${title}-root .${title}-details-root {
              padding-left: 0px;
            }
          }
          /* LG screens */
          @media only screen and (max-width: 992px) {
            .mob-none {
              display: none !important;
            }
            .desktop-none {
              display: flex !important;
            }
          }
          @media screen and (max-width: 679px) {
            .${title}-root {
              padding-left: 30px;
              padding-right: 30px;
            }
            .${title}-root .${title}-details-root {
              padding-right: 0px;
            }
          }
          @media screen and (max-width: 480px) {
            .${title}-root {
              padding-left: 20px;
              padding-right: 20px;
              padding-top: 30px;
              padding-bottom: 0px;
            }
            .${title}-root .${title}-details-root {
              padding-left: 10px;
              display: flex;
              flex-direction: column;
              align-items: start;
            }
            .${title}-root .${title}-details-root .${title}-title {
              font-weight: 800;
              font-size: 24px;
              line-height: 33px;
            }
            .${title}-root .${title}-details-root .${title}-text {
              font-weight: 700;
              font-size: 14px;
              line-height: 19px;
              width: 80%;
            }
            .${title}-root .${title}-details-root .${title}-subText {
              font-weight: 500;
              font-size: 16px;
              line-height: 22px;
            }
          }
        `}
      </style>
    </>
  );
};

export default ConferencesAndSummits;
